import { render, staticRenderFns } from "./levelinfo.vue?vue&type=template&id=65627853"
import script from "./levelinfo.vue?vue&type=script&lang=js"
export * from "./levelinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports